import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "67",
  height: "38",
  viewBox: "0 0 67 38",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "67",
      height: "8"
    }, null, -1),
    _createElementVNode("rect", {
      y: "15",
      width: "67",
      height: "8"
    }, null, -1),
    _createElementVNode("rect", {
      y: "30",
      width: "67",
      height: "8"
    }, null, -1)
  ])))
}
export default { render: render }